import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let SBProMenuAbout = class SBProMenuAbout extends Vue {
};
SBProMenuAbout = __decorate([
    Component({})
], SBProMenuAbout);
export default SBProMenuAbout;
